import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=1c297509"
import script from "./Body.vue?vue&type=script&setup=true&lang=js"
export * from "./Body.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c297509')) {
      api.createRecord('1c297509', component.options)
    } else {
      api.reload('1c297509', component.options)
    }
    module.hot.accept("./Body.vue?vue&type=template&id=1c297509", function () {
      api.rerender('1c297509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tooltips/Body.vue"
export default component.exports